import React, {useContext, useEffect, useState} from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import BotonVolver from '../components/BotonVolver';
import resourcesServices from '../services/resourcesServices';
import { errorMessage } from '../errorHandler';
import TextControlObligado from '../components/customizedInputs/TextControlObligado';
import TextControl from '../components/customizedInputs/TextControl';
import SelectControl from '../components/customizedInputs/SelectControl';


const ObligadoPendienteForm = () => {
  let { id } = useParams();
  const tipo_doc = ["dni", "lc", "le"]
  const estado_civil = ["soltero", "casado", "viudo", "divorciado"]
  const [usuario, setUsuario] = useState(false);
  const [saving, setSaving] = useState(false);
  const [obligadoExiste, setObligadoExiste] = useState(false);
  const [resource, setResource] = useState(false);
  const [preferencias, setPreferencias] = useState(false);
  const [declaracionJurada, setDeclaracionJurada] = useState(false);


  const navigate = useNavigate();
  const [authInformation] = useContext(InputContext)
  const [renderHTML, setRenderHTML] = useState(false)
  const [registroPdf, setRegistroPdf] = useState({})

  useEffect(() => {
    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( authInformation.autenticado === true && authInformation.rol === 'MesaEntrada'){
      setRenderHTML(true)
      fetchRegistroPDF(id)
      // nuevoUsuario()
    } else {
      setRenderHTML(false)
    }
  }, [authInformation]);

  const fetchRegistroPDF = async (id) => {
    try {
      const data = await resourcesServices.obtenerResourcePorId('registro_pdfs', id);

      // Verifico si el documento ya existe como usuario
      const data_usuario = await resourcesServices.obtenerResourcePorId('usuarios/obtenerPorDocumento', data.documento_identidad);
      if(data_usuario){
        setUsuario(data_usuario)
        const obligado_existe = data_usuario.roles.map(rol => rol.nombre).includes("Obligado")
        setObligadoExiste(obligado_existe)
      } else {
        setUsuario(false)
        setObligadoExiste(false)
      }
     
      setPreferencias(data.fields.preferencias_usuario_attributes)
      if(data.fields.declaracion_juradas_attributes){
        setDeclaracionJurada(data.fields.declaracion_juradas_attributes)
      } else {
        // TODO: 09/01/25 Esto es un arreglo para casos de obligados pendientes de aprobacion anterior a la actualizacion de multiples roles por usuario. Deberia borrarse en el futuro
        setDeclaracionJurada({
          f_cargo_desde: data.fields.preferencias_usuario_attributes.f_cargo_desde,
          f_cargo_hasta: data.fields.preferencias_usuario_attributes.f_cargo_hasta,
          numero_alta_norma_legal: data.fields.preferencias_usuario_attributes.numero_alta_norma_legal,
          numero_baja_norma_legal: data.fields.preferencias_usuario_attributes.numero_baja_norma_legal,
          cargo: data.fields.preferencias_usuario_attributes.cargo,
          organismo: data.fields.preferencias_usuario_attributes.organismo,
        })
      }
      delete data.fields.preferencias_usuario_attributes
      delete data.fields.declaracion_juradas_attributes
      
      setResource(data.cleaned_fields)


    } catch (error) {
      errorMessage(error)
    }
  };

  const aprobarObligado = async () => {
    try {
      if(!window.confirm('Está seguro que quiere activar al obligado?')) {
        return;
      }

      setSaving(true)

      await resourcesServices.crearResource(`usuarios/${id}/aprobarObligado`, {}, false);

      setSaving(false)
      alert("Obligado creado. Se le envió al obligado un email con su usuario y clave")
      navigate(`/obligadosPendientes`);

    } catch (error) {
      setSaving(false)
      errorMessage(error)
    }
  };



  return (
    <div>
      {renderHTML && (
        <>
        <h1>Creación de Obligado <BotonVolver /></h1>
        {
          usuario && usuario.id && (
            <div className="alert alert-success" role="alert">
              Existe un usuario con este documento en el rol:&nbsp;
              <b>
              {
                usuario.roles.map(rol => rol.nombre).join(' - ')
              }</b>
            </div>
          )
        }
        {/* <pre>{JSON.stringify(declaracionJurada, null, 2)}</pre> */}
        {
          resource && preferencias && declaracionJurada && (
          <form>
            <div className="row mt-3">
              <div className="col-6">
                <div className="card mb-5">
                  <div className="card-body">
                    <h5 className="card-title">Información personal</h5>
                      <TextControl
                        value={resource.nombre}
                        name={'nombre'}
                        disabled={true}
                      />
                      <TextControl
                        value={resource.apellido}
                        name={'apellido'}
                        disabled={true}
                      />
                      <TextControl
                        value={preferencias.f_nacimiento}
                        name={'f_nacimiento'}
                        label={"Fecha Nacimiento"}
                        hasLabel={true}
                        type={"date"}
                        disabled={true}
                      />
                      <SelectControl
                        value={preferencias.tipo_doc}
                        options={tipo_doc}
                        name={'tipo_doc'}
                        disabled={true}
                      />
                      <TextControl
                        value={resource.documento_identidad}
                        name={'documento_identidad'}
                        disabled={true}
                      />
                      <TextControl
                        value={preferencias.nacionalidad}
                        name={'nacionalidad'}
                        disabled={true}
                      />
                      <TextControl
                        value={preferencias.telefono_particular}
                        name={'telefono_particular'}
                        disabled={true}
                      />
                      <TextControl
                        value={preferencias.telefono_laboral}
                        name={'telefono_laboral'}
                        disabled={true}
                      />
                      <SelectControl
                        value={preferencias.estado_civil}
                        options={estado_civil}
                        required={true}
                        name={'estado_civil'}
                        disabled={true}
                      />
                      <TextControl
                        value={preferencias.nombre_conyuge}
                        name={'nombre_conyuge'}
                        disabled={true}
                      />
                      <TextControl
                        value={preferencias.apellido_conyuge}
                        name={'apellido_conyuge'}
                        disabled={true}
                      />

                  </div>
                </div>

                <div className="card mb-5">
                  <div className="card-body">
                    <h5 className="card-title">DDJJ</h5>
                      <TextControl
                        value={declaracionJurada.cargo}
                        name={'cargo'}
                        disabled={true}
                      />
                      <TextControl
                        value={declaracionJurada.organismo}
                        name={'organismo'}
                        disabled={true}
                      />

                      <TextControl
                        value={declaracionJurada.f_cargo_desde}
                        name={'f_cargo_desde'}
                        disabled={true}
                        hasLabel={true}
                        label={"Cargo Desde"}
                        type={"date"}
                      />
                      <TextControl
                        value={declaracionJurada.numero_alta_norma_legal}
                        name={'numero_alta_norma_legal'}
                        disabled={true}
                      />

                      <TextControl
                        value={declaracionJurada.f_cargo_hasta}
                        name={'f_cargo_hasta'}
                        disabled={true}
                        hasLabel={true}
                        label={"Cargo Hasta"}
                        type={"date"}
                      />
                      <TextControl
                        value={declaracionJurada.numero_baja_norma_legal}
                        name={'numero_baja_norma_legal'}
                        disabled={true}
                      />

                  </div>
                </div>


                <div className="card mb-5">
                  <div className="card-body">
                    <h5 className="card-title">Datos de Usuario</h5>
                      <TextControl
                        value={resource.email}
                        name={'email'}
                        disabled={true}
                        hasLabel={true}
                      />
                  </div>
                </div>

              </div>
              <div className="col-6">
                <div className="card mb-5">
                  <div className="card-body">
                    <h5 className="card-title">Domicilio Real</h5>
                      <TextControl
                        value={preferencias.calle_real}
                        name={'calle_real'}
                        disabled={true}
                        label={"Dirección (calle y nº)"}
                      />
                      <TextControl
                        value={preferencias.barrio_real}
                        name={'barrio_real'}
                        disabled={true}
                        label={"Barrio"}
                      />
                      <TextControl
                        value={preferencias.localidad_real}
                        name={'localidad_real'}
                        disabled={true}
                        label={"Localidad"}
                      />
                      <TextControl
                        value={preferencias.cp_real}
                        name={'cp_real'}
                        disabled={true}
                        label={"Código Postal"}
                      />
                  </div>
                </div>

                <div className="card mb-5">
                  <div className="card-body">
                    <h5 className="card-title">Domicilio Legal</h5>
                      <TextControl
                        value={preferencias.calle_legal}
                        name={'calle_legal'}
                        disabled={true}
                        label={"Dirección (calle y nº)"}
                      />
                      <TextControl
                        value={preferencias.barrio_legal}
                        name={'barrio_legal'}
                        disabled={true}
                        label={"Barrio"}
                      />
                      <TextControl
                        value={preferencias.localidad_legal}
                        name={'localidad_legal'}
                        disabled={true}
                        label={"Localidad"}
                      />
                      <TextControl
                        value={preferencias.cp_legal}
                        name={'cp_legal'}
                        disabled={true}
                        label={"Código Postal"}
                      />
                  </div>
                </div>

              </div>
            </div>
            {
              registroPdf.usuario && registroPdf.usuario.id && (
                <>
                <div className='alert alert-warning' role='alert'>
                  <b>Existe un usuario con este documento.</b><br />
                  Al guardar se van a actualizar los datos del usuario existente con los nuevos datos. <br />
                  La información del cargo anterior se va a archivar para ser reempazado por este nuevo cargo.
                </div>
                <div className='alert alert-warning' role='alert'>
                  <b>Nombre completo:</b> {registroPdf.usuario.nombre + ' ' + registroPdf.usuario.apellido}<br />
                  <b>Documento:</b> {registroPdf.usuario.documento_identidad}<br />
                  <b>Email:</b> {registroPdf.usuario.email}<br />
                  <b>Usuario:</b> {registroPdf.usuario.usuario}<br />
                </div>
                </>
              )
            }

            {
              obligadoExiste ? (
                <div className="alert alert-warning" role="alert">Este <b>número de documento</b> ya existe como Obligado</div>
              ) : (
              <button disabled={saving} className="btn btn-primary mt-3" onClick={() => aprobarObligado()} type="button">
                {saving && (<span className="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>)}
                <span role="status">Aprobar</span>
              </button>
              )
            }


          </form>
          )
        }
        </>
      )}
    </div>
  );
};

export default ObligadoPendienteForm;